import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'dayDiff',
  standalone: false
})
export class DayDifferencePipe implements PipeTransform {

  // TODO: implement with translations
  public transform(endDateStr?: string, startDateStr?: string): string {
    // if startDate not provided, will be compared to now
    const startDate = startDateStr ? dayjs(startDateStr) : dayjs();
    const endDate = dayjs(endDateStr);

    if (!endDateStr || startDate.isAfter(endDate)) {
      return 'N/A';
    }

    // If 0 days => give hours, if hours 0 as well => give minutes
    const daysDiff = endDate.diff(startDate, 'day');
    if (daysDiff === 0) {
      const hoursDiff = endDate.diff(startDate, 'hour');
      const minuteDiff = endDate.diff(startDate, 'minute');
      if (hoursDiff === 0) {
        return this.handleUnitDiff(minuteDiff, 'minute');
      }
      return this.handleUnitDiff(hoursDiff, 'hour');
    } 
    return this.handleUnitDiff(daysDiff, 'day');
  }

  private handleUnitDiff(diff: number, unit: 'day' | 'hour' | 'minute' ) {
    if (diff === 1) {
      return '1 ' + (unit === 'day' ? 'den' : unit === 'hour' ? 'hodinu' : unit === 'minute' ? 'minutu' : '');
    } else if ((diff >= 2) && (diff <= 4)) {
      return diff + (unit === 'day' ? ' dny' : unit === 'hour' ? ' hodiny' : unit === 'minute' ? ' minuty' : '');
    } else {
      return diff + (unit === 'day' ? ' dní' : unit === 'hour' ? ' hodin' : unit === 'minute' ? ' minut' : '');
    }
  }

}
